import {t} from '../../common/getTranslations';
import {TodayUpInvenStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/TodayUpInvenStaticLandingPageVo.interface';
import {TodayUpStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/TodayUpStaticLandingPageVo.interface';
import {
  Group,
  GroupType,
  LayoutType,
  ListViewGroup,
  Maybe,
  SectionType,
  StaticLandingTodayUpParamInput,
  StaticLandingTodayUpSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSortOption} from './SortOption';

export function createStaticLandingTodayUpSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    todayUpStaticLandingPageVo,
    todayUpInvenStaticLandingPageVo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    todayUpStaticLandingPageVo: TodayUpStaticLandingPageVo;
    todayUpInvenStaticLandingPageVo?: TodayUpInvenStaticLandingPageVo;
    input: StaticLandingTodayUpParamInput;
    type?: LayoutType;
  }
): StaticLandingTodayUpSection {
  const {
    categoryUid,
    subcategoryUid = todayUpStaticLandingPageVo.selected_subcat_opt?.param ||
      '0',
    page,
  } = input;
  const param = {
    categoryUid,
    subcategory: todayUpStaticLandingPageVo.selected_subcat_opt
      ? createSortOption({
          sortOptVo: todayUpStaticLandingPageVo.selected_subcat_opt,
        })
      : undefined,
    page,
  };

  const result = {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.TodayUp}-section-${type}-${param.categoryUid}-${param.subcategory?.param}`,
    type: SectionType.LandingTodayUp,
    groups: [
      {
        id: `static-landing-${StaticLandingType.TodayUp}-group-${param.categoryUid}-${param.subcategory?.param}`,
        type: GroupType.ListView,
        items:
          todayUpStaticLandingPageVo.list?.map((item, index) =>
            createNormalListViewItem(userInfo, {
              listViewLandingItemSeriesDto: {
                ...item,
                // 오늘 UP 페이지에서는 보여주지 않아야 하는 정보이므로 undefined로 할당합니다.
                last_slide_added_dt: undefined,
              },
            })
          ) || [],
      },
    ] as Group[],
    categoryTabList:
      todayUpStaticLandingPageVo.cat_opt_list?.map(opt =>
        createSortOption({sortOptVo: opt})
      ) || [],
    subcategoryList:
      todayUpStaticLandingPageVo.subcat_opt_list?.map(opt =>
        createSortOption({sortOptVo: opt})
      ) || [],
    totalCount: todayUpStaticLandingPageVo.total_count,
    isEnd: todayUpStaticLandingPageVo.is_end,
    param,
  };

  if (
    todayUpInvenStaticLandingPageVo?.list &&
    todayUpInvenStaticLandingPageVo.list.length > 0
  ) {
    result.groups.unshift({
      id: `static-landing-${StaticLandingType.TodayUp}-group-inven-${categoryUid}-${subcategoryUid}`,
      type: GroupType.ListView,
      meta: {
        title: t('landing_up_recently_viewed'),
      },
      items:
        todayUpInvenStaticLandingPageVo?.list?.map(item =>
          createNormalListViewItem(userInfo, {
            listViewLandingItemSeriesDto: {
              ...item,
              // 오늘 UP 페이지에서는 보여주지 않아야 하는 정보이므로 undefined로 할당합니다.
              last_slide_added_dt: undefined,
            },
          })
        ) || [],
    } as ListViewGroup);
  }
  return result;
}
